export const ADMIN_USERNAME = "admin";
export const ADMIN_PASSWORD = "Rencin@123";
export const ADMIN_SESSION_KEY = "rencin_admin_session";

export function isAdminCredentials(username, password) {
  return (
    String(username || "").trim() === ADMIN_USERNAME &&
    String(password || "") === ADMIN_PASSWORD
  );
}

export function getAdminSession() {
  try {
    const raw = localStorage.getItem(ADMIN_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.ok || parsed.username !== ADMIN_USERNAME) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setAdminSession() {
  localStorage.setItem(
    ADMIN_SESSION_KEY,
    JSON.stringify({ ok: true, username: ADMIN_USERNAME, createdAt: Date.now() }),
  );
}

export function clearAdminSession() {
  localStorage.removeItem(ADMIN_SESSION_KEY);
}
